import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  getMessageTemplateById,
  MessageTemplateDetail,
} from "#/services/messageTemplates";
import { getMessageTemplatePreviewSnippet } from "#/message-templates/utils/preview";

export function useMessageTemplatePreview(id: string, contextKey: string) {
  return useQuery<MessageTemplateDetail, Error, string>({
    queryKey: qk.messageTemplateSnippet({ id, contextKey }),
    queryFn: ({ signal }) => getMessageTemplateById(id, { signal }),
    select: (data) =>
      getMessageTemplatePreviewSnippet(data.content ?? data.body),
    enabled: Boolean(id),
    staleTime: 30_000,
  });
}

export default useMessageTemplatePreview;
